import { createContext } from "react";
var IsWithinNativeNavigator = createContext(false);
export {
  IsWithinNativeNavigator
};
//# sourceMappingURL=NativeNavigatorContext.js.map
